import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'ratings',
    templateUrl: 'ratings.component.html',
    styles: ['>>> .bold { font-weight: bold; }'],
    providers: []
})
export class RatingsComponent {
    constructor() { }
}